import React from "react";
import styles from "./Graphs.module.scss";

const Graphs = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.graph}>{children}</div>
);

export default Graphs;
